import { http } from '@/core/api'

export type PortalReferrerRow = {
  application_id: number
  captured_at: string | null
  referrer: {
    name: string
    phone: string
    identity_number: string
    identity_number_display: string
    address: string
    gender: string
    birth_date: string
    bank_account: string
    external: boolean
    worker_id: number | null
  }
  candidate: {
    worker_id: number | null
    full_name: string
    phone: string
  }
  job_order: {
    id: number | null
    code: string
    title: string
    client_name: string
  }
  recruiter: {
    id: number | null
    name: string
  }
  platform: {
    id: number
    code: string
    name: string
  } | null
  intake_source: string
  status: string
}

export type PortalReferrerListParams = {
  page?: number
  per_page?: number
  search?: string
  recruiter_id?: number
  job_order_id?: number
}

export type PortalReferrerListResponse = {
  items: PortalReferrerRow[]
  page: number
  per_page: number
  total: number
  last_page: number
}

export type PortalReferrerUpdatePayload = {
  referrer_name: string
  referrer_phone: string
  referrer_identity_number: string
  referrer_address: string
  referrer_gender: 'male' | 'female'
  referrer_birth_date: string
  referrer_bank_account?: string | null
}

export const portalReferrersApi = {
  async list(params: PortalReferrerListParams = {}): Promise<PortalReferrerListResponse> {
    const { data } = await http.get<{ data: PortalReferrerListResponse }>('/recruitment/portal-referrers', {
      params,
    })
    return data.data
  },

  async update(applicationId: number, payload: PortalReferrerUpdatePayload): Promise<PortalReferrerRow> {
    const { data } = await http.patch<{ data: PortalReferrerRow }>(
      `/recruitment/portal-referrers/${applicationId}`,
      payload,
    )
    return data.data
  },
}
